export default __webpack_public_path__ + "static/media/thrivingpets-logo-dark.52aa77ae.svg";